var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.content.sections),function(section){return _c('NuxtDynamic',{key:section.id,attrs:{"section":section,"component":("frontend-" + (section.component))}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }